export function stripMarkdown(markdown: string): string {
    return markdown
        .replace(/```[\s\S]*?```/g, ' ')
        .replace(/`([^`]*)`/g, '$1')
        .replace(/!\[([^\]]*)\]\([^)]*\)/g, '$1')
        .replace(/\[([^\]]*)\]\([^)]*\)/g, '$1')
        .replace(/^\s{0,3}#{1,6}\s+/gm, '')
        .replace(/^\s{0,3}>\s?/gm, '')
        .replace(/^\s{0,3}([-*+]|\d+[.)])\s+/gm, '')
        .replace(/^\s*\|.*\|\s*$/gm, ' ')
        .replace(/^\s*([-*_])\s*(\1\s*){2,}$/gm, ' ')
        .replace(/(^|[^\w*])\*\*([^*]+)\*\*(?![\w*])/g, '$1$2')
        .replace(/(^|[^\w_])__([^_]+)__(?![\w_])/g, '$1$2')
        .replace(/(^|[^\w*])\*([^*\s][^*]*)\*(?![\w*])/g, '$1$2')
        .replace(/(^|[^\w_])_([^_\s][^_]*)_(?![\w_])/g, '$1$2')
        .replace(/~~([^~]+)~~/g, '$1')
        .replace(/\s+/g, ' ')
        .trim();
}
